<template>
    <v-app id="signup" class="primary general-form-wrapper">
        <v-content>
            <v-container fluid fill-height>
                <v-layout align-center justify-center>
                    <v-flex xs12 sm8 md4 lg4>
                        <v-form id="signup_form" method="post" :action="form.action" v-model="form.valid" v-on:success="signupSuccess" ref="signup_form">
                            <!--<input type="hidden" name="timezone" v-model="timezone">-->

                            <v-card class="elevation-1 pa-3">

                                <v-alert
                                  :value="errors.general!==''"
                                  type="error"
                                >
                                  {{errors.general}}
                                </v-alert>

                                <v-card-text>
                                    <div class="layout column align-center">
                                        <!--<img src="/static/m.png" alt="Vue Material Admin" width="120" height="120">-->
                                        <h1 class="flex my-4 primary--text">{{ $t("login.signup") }} - {{$t('app.name')}}</h1>
                                    </div>

                                    <div class="text-xs-center">

                                        <v-dialog
                                                v-model="intro_dialog"
                                                width="500"
                                        >
                                            <v-card>
                                                <v-card-title
                                                        class="headline blue darken-2 white--text"
                                                        primary-title
                                                >
                                                    {{$t('app.name')}}
                                                </v-card-title>

                                                <v-card-text class="intro-content" v-html="$t('login.jitevent_intro_content')"></v-card-text>

                                                <v-card-text class="intro-footer">
                                                    {{$t('login.jitevent_intro_footer')}}
                                                </v-card-text>

                                                <v-divider></v-divider>

                                                <v-card-actions>
                                                    <v-spacer></v-spacer>
                                                    <v-btn
                                                            color="primary"
                                                            flat
                                                            @click="intro_dialog = false"
                                                    >{{$t('action.close')}}</v-btn>
                                                </v-card-actions>
                                            </v-card>
                                        </v-dialog>


                                        <v-btn flat small color="primary" class="text-capitalize" @click="intro_dialog = true">{{$t("login.what_is_jitevent")}}</v-btn>
                                    </div>

                                    <v-text-field
                                      type="text"
                                      name="firstname"
                                      ref="firstname"
                                      maxlength="255"
                                      :rules="[rules.required]"
                                      :error-messages="errors.firstname"
                                      :label="$t('user.first_name')"
                                      append-icon="person"
                                    >
                                    </v-text-field>
                                    <v-text-field
                                      type="text"
                                      ref="lastname"
                                      name="lastname"
                                      maxlength="255"
                                      :error-messages="errors.lastname"
                                      :label="$t('user.last_name')"
                                      append-icon="person"
                                    >
                                    </v-text-field>
                                    <v-text-field
                                      type="text"
                                      ref="email"
                                      name="email"
                                      maxlength="255"
                                      :rules="[rules.required, rules.email]"
                                      :error-messages="errors.email"
                                      :label="$t('user.email')"
                                      append-icon="email"
                                      autocomplete="none"
                                    >
                                    </v-text-field>
                                    <v-text-field
                                      type="password"
                                      ref="password"
                                      name="password"
                                      v-model="form.password"
                                      maxlength="20"
                                      :rules="[rules.required, rules.password]"
                                      :error-messages="errors.password"
                                      :label="$t('login.password')"
                                      append-icon="lock"
                                    >
                                    </v-text-field>
                                    <v-text-field
                                      type="password"
                                      ref="confirm_password"
                                      name="confirm_password"
                                      maxlength="20"
                                      :rules="[rules.required, rules.confirm_password]"
                                      :error-messages="errors.password"
                                      :label="$t('login.confirm_password')"
                                      append-icon="lock"
                                    >
                                    </v-text-field>
                                    <v-checkbox
                                      :error-messages="errors.tnc"
                                      ref="tnc"
                                      value="1"
                                      name="tnc"
                                    >
<!--                                        <span slot="label">{{$t('form.i_agree')}}<b @click.prevent.stop="dialog = true">{{$t('form.tnc')}}</b></span>-->
                                        <span slot="label">{{$t('form.i_agree')}}<a @click.prevent.stop="openPrivacy()">{{$t('form.tnc')}}</a></span>
                                    </v-checkbox>
                                    <v-dialog
                                      v-model="dialog"
                                      width="500"
                                    >
                                        <v-card>
                                            <v-card-title
                                              class="headline grey lighten-2"
                                              primary-title
                                            >
                                              {{$t('form.tnc')}}
                                            </v-card-title>

                                            <v-card-text>{{$t('form.tnc_content')}}</v-card-text>

                                            <v-divider></v-divider>

                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn
                                                  color="primary"
                                                  flat
                                                  @click="dialog = false"
                                                >
                                                  {{$t('action.close')}}
                                                </v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>
                                </v-card-text>
                                <v-card-actions>
                                    <v-btn
                                      block
                                      color="primary"
                                      type="submit"
                                      ref="submit"
                                      :loading="form.loading"
                                    >
                                        {{$t('form.submit')}}
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-form>
                        <div class="text-xs-center">
                            <v-btn flat color="primary" :to="{name: 'public_login'}">{{$t('login.button')}}</v-btn>
                        </div>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-content>
        <app-footer></app-footer>
    </v-app>
</template>

<script>
    import FormHandling from '~/utils/data/form-handling'
    import {UrlServices, BACKEND_URL} from '~/utils/url-manager'
    import AppFooter from "~/components/AppFooter";

    export default {
        components: {
            AppFooter
        },
        data() {
            return {
                rules: {
                    required: value => !!value || this.$t('form.field_required'),
                    email: value => {
                        this.errors.email = '';
                        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                        return pattern.test(value) || this.$t('login.email_invalid')
                    },
                    password: value => {
                        const pattern = /^[\w\.\-!@#$%^&*]{8,20}$/
                        return pattern.test(value) || this.$t('login.password_invalid')
                    },
                    confirm_password: value => {
                        return value === this.form.password || this.$t('login.confirm_password_different')
                    },
                    agree: value => !!value || this.$t('form.must_agree_tnc'),
                },
                form: {
                    action: UrlServices.createUrl({name: 'api_signup'}),
                    loading: false,
                    valid: false,
                    password: ''
                },
                errors: {
                    general: '',
                    firstname: '',
                    lastname: '',
                    email: '',
                    password: '',
                    tnc: ''
                },
                dialog: false,
                intro_dialog: false
            }
        },
        computed: {
            // timezone() {
            //     let diffMinutes = new Date().getTimezoneOffset();
            //     console.log('Timezone', -diffMinutes/60);
            //     return -diffMinutes/60;
            // }
        },
        methods: {
            signupSuccess() {
                window.getApp.$emit('APP_SIGNUP_SUCCESS');
            },
            openPrivacy() {
                window.open('https://www.optitable.com/optievent-privacy/', '_blank')
            }
        },
        mounted: function() {
            new FormHandling(this, "signup_form");
        }
    };
</script>
<style scoped>
    .intro-content {
        font-size: 1.1em;
    }

    .intro-footer {
        font-size: 1.2em;
    }
</style>
